import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import MainContent from "./mainContent";
import SelectProject from "../../assets/images/icons/select-project.svg";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { getAllProject, getProjectDetails } from "../../api/casp/project";
import { ProjectStatuses } from "../../constants/Status";
import { useSelector } from "react-redux";
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { getIconPath } from "../../helpers/file_helper";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";

const ChangeRequest = (props) => {
  const [selectedProject, setSelectedProject] = useState();
  const  [alreadyCreated, setAlreadyCreated] = useState(false);
  const [refreshComponent, setRefreshComponent] = useState(+new Date());
  const [serviceProviderAccordionExpand, setServiceProviderAccordionExpand] =
    useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const { project } = useParams()
  const getProjectInformation = async(id) => {
    try {
      const response = await getProjectDetails(id)
      return response.data.data
    } catch (e) {
      console.error(e)
      return undefined
    }
  }
  useEffect(() => {
    if (project) {
      getProjectInformation(project).then((projectInfo) => {
        setSelectedProject(projectInfo)

        if(projectInfo._count.changeRequests){
          setAlreadyCreated(true)
          return toast.error('You cannot create a new change request until the existing one is approved')
        }
        setServiceProviderAccordionExpand(!!projectInfo)
        setRefreshComponent(+new Date())
      })
    } else {
      setSelectedProject()
      setServiceProviderAccordionExpand(false)
      setRefreshComponent(+new Date())
    }
  }, [project])

  const manageServiceProviderAccordion = () => {
    setServiceProviderAccordionExpand(!serviceProviderAccordionExpand);
  };

  return (
    <React.Fragment>
      <div className="page-content change-req-pg position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, 'linkTags', []), {
                rel: 'icon',
              })

              if (!newFaviconElems.length) {
                return
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              )

              if (existingFavicons.length) {
                existingFavicons.forEach(e => e.parentNode.removeChild(e))
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              )

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true)
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<PublishedWithChangesIcon />)}</svg>`
                )}`
                const parentElem = newFaviconElem.parentNode
                parentElem.removeChild(newFaviconElem)
                parentElem.appendChild(newFavElement)
              }
            } catch (e) {
              console.error(e)
            }
          }}
        >
          <title>{props.t('Create Change Request')}</title>
        </Helmet>
        <Container fluid>
          {selectedProject ? (
            <MainContent projectId={selectedProject.id} setSelectedProject={setSelectedProject} alreadyCreated ={alreadyCreated}/>
          ) : (
            <div className="project_select_name w-100">
              <img
                src={SelectProject}
                alt={SelectProject}
                style={{ marginRight: "10px" }}
              />
              {props.t('Select Startup')}
              {serviceProviderAccordionExpand && (
                <SearchDropDownListPaginationComponent
                  label="Select Startup"
                  searchEnabled={false}
                  listCall={getAllProject}
                  emitItem={(newValue) => {
                    setSelectedProject(newValue || null);
                  }}
                  apiParams={{
                    userId: loggedInUser.id,
                    filterFields: ["status"],
                    filterInputs: [
                      `${ProjectStatuses.CONFIRMATION_REJECTED},${ProjectStatuses.ONGOING}`,
                    ],
                    order: "updatedAt",
                    direction: "desc",
                  }}
                />
              )}
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(ChangeRequest);
